module.exports = __webpack_public_path__ + "img/transfer-img.3b37b4d3.svg";